import { passwordStrengthRules } from '@/lib/validations/auth'

// Static password rule list (AC-2.1.2-015/032), styled per Figma reset-password screen.
export function PasswordStrengthIndicator() {
  return (
    <ul
      className='flex list-disc flex-col gap-2 pl-[21px] text-sm font-normal leading-[1.4] text-[#3D434E]'
      aria-live='polite'
    >
      {passwordStrengthRules.map(r => (
        <li key={r.key}>{r.label}</li>
      ))}
    </ul>
  )
}

export default PasswordStrengthIndicator
